module.exports = __webpack_public_path__ + "img/dolar.080dbea9.svg";